import apiClient from './client';

export const getCustomerAliases = async (): Promise<Record<string, string>> => {
    const { data } = await apiClient.get('/customer-aliases');
    return data;
};

export const updateCustomerAlias = async (customerPhone: string, customNick: string): Promise<any> => {
    const { data } = await apiClient.post('/customer-aliases', { customerPhone, customNick });
    return data;
};
